export function objectToQueryString(object: Record<string, any>): string {
  const params = new URLSearchParams();

  Object.keys(object).forEach((key) => {
    const value = object[key];

    if (Array.isArray(value)) {
      value.forEach((item) => params.append(key, item));
    } else {
      params.append(key, value);
    }
  });

  return params.toString();
}
